import { getFileUrl, isPdf, isImage } from '@/utils/fileUrl';

/**
 * Inline file preview that renders a PDF iframe, an image, or falls back to iframe.
 * Replaces nested ternaries in invoice/DDT/document preview dialogs.
 */
export function FilePreview({ url, title }) {
  if (!url) return null;
  const src = getFileUrl(url);
  if (isImage(url)) {
    return (
      <img
        src={src}
        alt={title || 'Anteprima'}
        className="max-w-full max-h-full object-contain mx-auto"
      />
    );
  }
  // PDF or unknown → iframe (most browsers handle PDF natively)
  return (
    <iframe
      src={src}
      className="w-full h-full rounded border"
      title={title || 'Anteprima'}
    />
  );
}

/**
 * Pure helper: returns the right "scadenza" badge variant for an invoice row.
 * Replaces nested ternaries in FattureEntrata/FattureUscita.
 */
export function scadenzaState(scadenza, todayIso, stato) {
  if (stato === 'pagata' || stato === 'incassata') return 'paid';
  if (!scadenza) return 'none';
  if (scadenza < todayIso) return 'overdue';
  return 'pending';
}

// Bound check (used by `isPdf` is already imported by callers — re-exporting helps)
export { isPdf, isImage, getFileUrl };
